import { AnyAction } from 'redux';

import { SET_FLOW_STEP } from './constants';

type StateId = string;

interface FlowSingleState {
  stepId: string;
  stepIndex: number;
}

export type FlowsState = Record<StateId, FlowSingleState>;

export const initialState: FlowsState = {};

export const flowsReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_FLOW_STEP:
      return {
        ...state,
        [action.stateId]: {
          stepId: action.stepId,
          stepIndex: action.stepIndex,
        },
      };

    default:
      return state;
  }
};
